module.exports = __webpack_public_path__ + "static/media/S2N8-1.5780a240.svg";